import { createContext } from 'react';

/**
 * 모달의 상태와 함수를 하위 컴포넌트에 전달하기 위한 React Context입니다.
 * 이 Context를 통해 어떤 컴포넌트에서든 모달을 열 수 있습니다.
 */
export const ModalContext = createContext(null);
